exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-02db315e]{width:100%}table[data-v-02db315e],td[data-v-02db315e],th[data-v-02db315e]{border:1px solid #ddd}td[data-v-02db315e],th[data-v-02db315e]{padding:8px 16px;vertical-align:middle}th[data-v-02db315e]{background-color:#eee;width:140px}", ""]);

// exports
